/*
 *                     NOTICE
 *            COPYRIGHT 2019 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { AbAutoSizer as AbAutoSizerImpl } from "abreact/layout/AbAutoSizer";
import * as React from "react";

/**
 * The properties for an AbAutoSizer.
 */

/**
 * A React container that automatically sizes to the space provided by its parent.
 *
 * [[include:absdk/commons/ui/layout/AbAutoSizer.md]]
 */
export function AbAutoSizer(props) {
  return /*#__PURE__*/React.createElement(AbAutoSizerImpl, props);
}
//# sourceMappingURL=AbAutoSizer.js.map
